export default "__VITE_ASSET__42E$02lw__"